import { Box, Stack, TextField } from "@mui/material";
import React, { Dispatch, memo, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";

import FiltersActions from "../../../../components/FiltersActions/FiltersActions";
import useFilter from "../../../../hooks/useFilter";

import { DatePickerUncontrolled, DateRangeSelect } from "@4uhub/lib4uhub";

interface IMacroFilterProps {
  onFilterParams: Dispatch<SetStateAction<IFilterParams>>;
  filterParams: IFilterParams;
}

export interface IFilterParams {
  Status: string;
  DateStart: Date | null;
  DateEnd?: Date | null;
  Solved: string;
  refresh?: boolean;
}

const translationPath = "page.4uBus.logs.logFileIntegration.";

const MacroFilter: React.FC<IMacroFilterProps> = ({
  onFilterParams,
  filterParams,
}) => {
  const { filter, showCleanBtn, initialState, setFilter, cleanFilter } =
    useFilter(filterParams);

  const { t } = useTranslation();

  const filterHandler = () => {
    onFilterParams(filter);
  };

  const [resetDateRange, setResetDateRange] = useState<boolean>(false);
  const cleanHandler = () => {
    onFilterParams(initialState.current);
    cleanFilter();
    setResetDateRange((prev) => !prev);
  };

  const [enableFields, setEnableFields] = useState<boolean>(true);

  const handleStartDate = (date: Date | null) => {
    setFilter({ DateStart: date });
  };
  const handleEndDate = (date: Date | null) => {
    setFilter({ DateEnd: date });
  };

  // const noFilterSelected =
  //   !filter.DateStart &&
  //   !filter.DateEnd &&
  //   !filter.Status.trim() &&
  //   !filter.Solved.trim();

  return (
    <Stack flexDirection={"row"} gap={2} alignItems="center">
      <DateRangeSelect
        setEndDate={handleEndDate}
        setStartDate={handleStartDate}
        setEnableFields={setEnableFields}
        resetToToday={resetDateRange}
      />
      <Box sx={{ flex: "0 0 160px" }}>
        <DatePickerUncontrolled
          value={filter.DateStart}
          onChange={(e) => setFilter({ DateStart: e })}
          label={`${t(translationPath + "start_date")}`}
          isClearable={false}
          disable={enableFields}
        />
      </Box>
      <Box sx={{ flex: "0 0 160px" }}>
        <DatePickerUncontrolled
          value={filter.DateEnd}
          onChange={(e) => setFilter({ DateEnd: e })}
          label={`${t(translationPath + "end_date")}`}
          isClearable={false}
          disable={enableFields}
        />
      </Box>

      <TextField
        value={filter.Status}
        size="small"
        label={t(translationPath + "status")}
        fullWidth
        onChange={(e) => setFilter({ Status: e.target.value })}
      />

      <TextField
        value={filter.Solved}
        size="small"
        label={t(translationPath + "resolved")}
        fullWidth
        onChange={(e) => setFilter({ Solved: e.target.value })}
      />

      <FiltersActions
        onFilter={filterHandler}
        onClean={cleanHandler}
        // disableFilterBtn={noFilterSelected}
        showCleanBtn={showCleanBtn}
      />
    </Stack>
  );
};

export default memo(MacroFilter);
